/**
 * oddit-header.js
 * Header interactions: mega menu, mobile drawer, cart/search toggles
 */
(function () {
  var SECTION_SELECTOR = '.oddit-header';

  function initSection(section) {
    if (!section) return;

    // AbortController for document-level listeners scoped to this section instance
    var controller = new AbortController();
    var signal = controller.signal;
    section._odditHeaderAbort = controller;

    /* ------------------------------------------------------------------
       Shared Overlay
       ------------------------------------------------------------------ */
    var overlay = document.getElementById('oddit-overlay');
    var overlayCloseCallback = null;

    function showOverlay(onClose) {
      if (!overlay) return;
      overlayCloseCallback = onClose || null;
      overlay.classList.add('is-active');
      overlay.setAttribute('aria-hidden', 'false');
    }

    function hideOverlay() {
      if (!overlay) return;
      overlay.classList.remove('is-active');
      overlay.setAttribute('aria-hidden', 'true');
      overlayCloseCallback = null;
    }

    if (overlay) {
      overlay.addEventListener('click', function () {
        if (overlayCloseCallback) overlayCloseCallback();
        hideOverlay();
      });
    }

    /* ------------------------------------------------------------------
       Desktop Mega Menu
       ------------------------------------------------------------------ */
    var megaMenuTriggers = section.querySelectorAll('[data-mega-menu-trigger]');
    var megaMenuPanels = section.querySelectorAll('[data-mega-menu-panel]');
    var activeMegaLabel = null;

    function closeSearchIfOpen() {
      var sb = section.querySelector('[data-search-bar]');
      if (sb && sb.classList.contains('is-open')) {
        sb.classList.remove('is-open');
        sb.setAttribute('aria-hidden', 'true');
        section.classList.remove('search-open');
        var si = section.querySelector('[data-search-input]');
        if (si) si.value = '';
      }
    }

    function openMegaMenu(label) {
      closeSearchIfOpen();
      for (var i = 0; i < megaMenuPanels.length; i++) {
        var panel = megaMenuPanels[i];
        if (panel.getAttribute('data-mega-menu-label') === label) {
          panel.classList.add('is-open');
          panel.setAttribute('aria-hidden', 'false');
        } else {
          panel.classList.remove('is-open');
          panel.setAttribute('aria-hidden', 'true');
        }
      }
      for (var j = 0; j < megaMenuTriggers.length; j++) {
        var trigger = megaMenuTriggers[j];
        trigger.setAttribute('aria-expanded',
          trigger.getAttribute('data-mega-menu-label') === label ? 'true' : 'false'
        );
      }
      section.classList.add('mega-menu-open');
      activeMegaLabel = label;
    }

    function closeMegaMenu() {
      for (var i = 0; i < megaMenuPanels.length; i++) {
        megaMenuPanels[i].classList.remove('is-open');
        megaMenuPanels[i].setAttribute('aria-hidden', 'true');
      }
      for (var j = 0; j < megaMenuTriggers.length; j++) {
        megaMenuTriggers[j].setAttribute('aria-expanded', 'false');
      }
      section.classList.remove('mega-menu-open');
      activeMegaLabel = null;
    }

    for (var t = 0; t < megaMenuTriggers.length; t++) {
      (function (trigger) {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          var label = trigger.getAttribute('data-mega-menu-label');
          if (activeMegaLabel === label) {
            closeMegaMenu();
          } else {
            openMegaMenu(label);
          }
        });

        trigger.addEventListener('mouseenter', function () {
          var label = trigger.getAttribute('data-mega-menu-label');
          openMegaMenu(label);
        });
      })(megaMenuTriggers[t]);
    }

    // Close mega menu when hovering over non-dropdown nav items
    var allNavLinks = section.querySelectorAll('.oddit-header__nav-link:not(.oddit-header__nav-link--has-dropdown)');
    for (var n = 0; n < allNavLinks.length; n++) {
      allNavLinks[n].addEventListener('mouseenter', function () {
        if (activeMegaLabel) {
          closeMegaMenu();
        }
      });
    }

    // Close mega menu when hovering over the logo or icons
    var logo = section.querySelector('.oddit-header__logo-link');
    var icons = section.querySelector('.oddit-header__icons');
    if (logo) {
      logo.addEventListener('mouseenter', function () {
        if (activeMegaLabel) closeMegaMenu();
      });
    }
    if (icons) {
      icons.addEventListener('mouseenter', function () {
        if (activeMegaLabel) closeMegaMenu();
      });
    }

    // Close mega menu when clicking outside
    document.addEventListener('click', function (e) {
      if (!activeMegaLabel) return;
      if (!e.target.closest('[data-mega-menu-trigger]') &&
          !e.target.closest('[data-mega-menu-panel]')) {
        closeMegaMenu();
      }
    }, { signal: signal });

    // Close mega menu on mouseleave from the panel
    for (var p = 0; p < megaMenuPanels.length; p++) {
      megaMenuPanels[p].addEventListener('mouseleave', function (e) {
        var related = e.relatedTarget;
        if (!related || (!related.closest('[data-mega-menu-trigger]') &&
            !related.closest('[data-mega-menu-panel]') &&
            !related.closest('.oddit-header__wrapper'))) {
          closeMegaMenu();
        }
      });
    }

    // Close mega menu when mouse leaves the header wrapper (going up/left/right)
    var wrapper = section.querySelector('.oddit-header__wrapper');
    if (wrapper) {
      wrapper.addEventListener('mouseleave', function (e) {
        if (!activeMegaLabel) return;
        var related = e.relatedTarget;
        if (related && (related.closest('[data-mega-menu-panel]') ||
            related.closest('.oddit-header__search'))) return;
        closeMegaMenu();
      });
    }

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && activeMegaLabel) {
        closeMegaMenu();
      }
    }, { signal: signal });

    /* ------------------------------------------------------------------
       Mobile Menu
       ------------------------------------------------------------------ */
    var mobileMenu = section.querySelector('[data-mobile-menu]');
    var mobileMenuOverlay = section.querySelector('[data-mobile-menu-overlay]');
    var mobileMenuToggle = section.querySelector('[data-mobile-menu-toggle]');
    var mobileMenuMain = section.querySelector('[data-mobile-menu-main]');
    var hamburgerIcon = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.66667 5.33333H13.3333M2.66667 10.6667H13.3333" stroke="#ffffff" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var closeIcon = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 2.9625L12.0375 2L7.5 6.5375L2.9625 2L2 2.9625L6.5375 7.5L2 12.0375L2.9625 13L7.5 8.4625L12.0375 13L13 12.0375L8.4625 7.5L13 2.9625Z" fill="#212529"/></svg>';

    function openMobileMenu() {
      if (!mobileMenu) return;
      closeSearchIfOpen();
      mobileMenu.classList.add('is-open');
      mobileMenu.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      showOverlay(closeMobileMenu);
      if (mobileMenuToggle) {
        mobileMenuToggle.innerHTML = closeIcon;
        mobileMenuToggle.classList.add('is-close');
        mobileMenuToggle.setAttribute('aria-label', 'Close menu');
      }
    }

    function closeMobileMenu() {
      if (!mobileMenu) return;
      var openSubmenus = mobileMenu.querySelectorAll('.oddit-header__mobile-submenu.is-open');
      for (var i = 0; i < openSubmenus.length; i++) {
        openSubmenus[i].classList.remove('is-open');
        openSubmenus[i].setAttribute('aria-hidden', 'true');
      }
      mobileMenu.classList.remove('is-open');
      mobileMenu.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      hideOverlay();
      if (mobileMenuToggle) {
        mobileMenuToggle.innerHTML = hamburgerIcon;
        mobileMenuToggle.classList.remove('is-close');
        mobileMenuToggle.setAttribute('aria-label', 'Open menu');
      }
    }

    if (mobileMenuToggle) {
      mobileMenuToggle.addEventListener('click', function () {
        if (mobileMenu && mobileMenu.classList.contains('is-open')) {
          closeMobileMenu();
        } else {
          openMobileMenu();
        }
      });
    }

    if (mobileMenuOverlay) {
      mobileMenuOverlay.addEventListener('click', closeMobileMenu);
    }

    // Mobile submenu triggers
    var submenuTriggers = section.querySelectorAll('[data-mobile-submenu-trigger]');
    for (var s = 0; s < submenuTriggers.length; s++) {
      (function (trigger) {
        trigger.addEventListener('click', function () {
          var targetId = trigger.getAttribute('data-mobile-submenu-trigger');
          var submenu = section.querySelector('[data-mobile-submenu="' + targetId + '"]');
          if (submenu) {
            submenu.classList.add('is-open');
            submenu.setAttribute('aria-hidden', 'false');
            var backBtn = submenu.querySelector('[data-mobile-submenu-back]');
            if (backBtn) {
              requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                  backBtn.focus();
                });
              });
            }
          }
        });
      })(submenuTriggers[s]);
    }

    // Mobile submenu back buttons
    var submenuBacks = section.querySelectorAll('[data-mobile-submenu-back]');
    for (var b = 0; b < submenuBacks.length; b++) {
      (function (backBtn) {
        backBtn.addEventListener('click', function () {
          var submenu = backBtn.closest('.oddit-header__mobile-submenu');
          if (submenu) {
            submenu.classList.remove('is-open');
            submenu.setAttribute('aria-hidden', 'true');
          }
        });
      })(submenuBacks[b]);
    }

    // Close mobile menu on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('is-open')) {
        closeMobileMenu();
      }
    }, { signal: signal });

    /* ------------------------------------------------------------------
       Cart Drawer Toggle
       ------------------------------------------------------------------ */
    var cartToggles = section.querySelectorAll('[data-cart-toggle]');
    for (var i = 0; i < cartToggles.length; i++) {
      cartToggles[i].addEventListener('click', function () {
        if (window.OdditCartDrawer) {
          window.OdditCartDrawer.open();
        }
      });
    }

    /* ------------------------------------------------------------------
       Search Bar Toggle
       ------------------------------------------------------------------ */
    var searchBar = section.querySelector('[data-search-bar]');
    var searchInput = section.querySelector('[data-search-input]');
    var searchForm = section.querySelector('[data-search-form]');
    var searchToggles = section.querySelectorAll('[data-search-toggle]');
    var searchCloseButtons = section.querySelectorAll('[data-search-close]');

    function openSearch() {
      if (!searchBar) return;
      closeMegaMenu();
      closeMobileMenu();
      searchBar.classList.add('is-open');
      searchBar.setAttribute('aria-hidden', 'false');
      section.classList.add('search-open');
      showOverlay(closeSearch);
      if (searchInput) {
        requestAnimationFrame(function () {
          searchInput.focus();
        });
      }
    }

    function closeSearch() {
      if (!searchBar) return;
      searchBar.classList.remove('is-open');
      searchBar.setAttribute('aria-hidden', 'true');
      section.classList.remove('search-open');
      hideOverlay();
      if (searchInput) searchInput.value = '';
    }

    for (var i = 0; i < searchToggles.length; i++) {
      searchToggles[i].addEventListener('click', function () {
        if (searchBar && searchBar.classList.contains('is-open')) {
          closeSearch();
        } else {
          openSearch();
        }
      });
    }

    for (var i = 0; i < searchCloseButtons.length; i++) {
      searchCloseButtons[i].addEventListener('click', closeSearch);
    }

    if (searchForm) {
      searchForm.addEventListener('submit', function (e) {
        if (searchInput && searchInput.value.trim() === '') {
          e.preventDefault();
        }
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchBar && searchBar.classList.contains('is-open')) {
        closeSearch();
      }
    }, { signal: signal });
  }

  function destroySection(section) {
    document.body.style.overflow = '';
    if (section && section._odditHeaderAbort) {
      section._odditHeaderAbort.abort();
      section._odditHeaderAbort = null;
    }
  }

  /* --------------------------------------------------------------------
     Cart Count Badge (global — registered once)
     -------------------------------------------------------------------- */
  document.addEventListener('cart:updated', function (e) {
    var cart = e.detail.cart;
    var badges = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = '(' + cart.item_count + ')';
      badges[i].style.display = cart.item_count > 0 ? '' : 'none';
    }
  });

  // Init
  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  // Shopify theme editor events
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();